import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SubscriptionCard from '../../components/SubscriptionCard';

const SubscriptionsView = ({ customerId }) => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSubscriptions = async () => {
      if (!customerId) return;
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/subscription/latest/${customerId}`
        );
        // Response shape based on LookingGlass API docs
        const subscription = res?.data?.data;
        setSubscriptions(subscription ? [subscription] : []);
      } catch (err) {
        const errorMessage =
          err.response?.data?.message || err.message || 'Failed to load subscriptions';
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptions();
  }, [customerId]);

  if (loading) return <div>Loading subscriptions...</div>;
  if (error) return <div className="error-box">{error}</div>;
  if (!subscriptions.length) return <div>No subscriptions found.</div>;

  return (
    <div className="subscriptions-grid">
      {subscriptions.map(sub => (
        <SubscriptionCard key={sub.id} subscription={sub} />
      ))}
    </div>
  );
};

export default SubscriptionsView;
